import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PenalCourrierService } from '../../services/penal.courrier/penal.courrier.service';
import { AlertesService } from '../../services/public/alertes.service';
import { PublicService } from '../../services/public/public.service';
import { ServicesService } from '../../services/public/services.service';
import { SuccessDialogComponent } from '../../widgets/successDialog/success-dialog.component';
import { AddPaymentComponent } from '../add-payment/add-payment.component';
import * as $ from 'jquery';
import { RemplirformsservicepublicComponent } from '../remplirformsservicepublic/remplirformsservicepublic.component';
import { DatePipe } from '@angular/common';
import { VisualizePieceComponent } from '../visualize-piece/visualize-piece.component';
import { AddPublicServiceComponent } from '../add-public-service/add-public-service.component';
import { DocumentGenerationPublicComponent } from '../document-generation-public/document-generation-public.component';
import { AddPiecePublicdemandeComponent } from '../add-piece-publicdemande/add-piece-publicdemande.component';

@Component({
  selector: 'app-view-details-servicepublic',
  templateUrl: './view-details-servicepublic.component.html',
  styleUrls: ['./view-details-servicepublic.component.scss']
})
export class ViewDetailsServicepublicComponent {
  @Input() parentModal: BsModalRef;



  DEMANDE_TO_FORMS: any = [];
  data: any;
  operation_ref: any;
  _isTraitement: any;


  IS_TRAITEMENT = false;
  ALLOW_MISE_EN_FORME = false;

  ELECTRONIC_DOC = false;
  ELECTRONIC_DOC_DETAIL = null;

  STATUS = 'OK';
  STATUS_COMPLEMENT = 'OK';
  loadingServiceForms = true;
  noForm = true;
  can_show = true
  demandeForm: FormGroup;
  KEYS: any;
  KEYS_GEN: any;

  SERVICE: any
  OPERATION_REF: any
  status: any
  is_mobile = false

  custumData: any = null
  traitement_ref: any = null
  operation_ref_ext: any = null



  constructor(private modalService: BsModalService,
    private service: ServicesService,
    private publicService: PublicService,
    private alerte: AlertesService,
    private datePipe: DatePipe,
    private bsrefModal: BsModalRef,
    public options: ModalOptions, private penalService: PenalCourrierService, private formBuilder: FormBuilder, private ngxService: NgxUiLoaderService, private modalRef: BsModalRef) {
    this.data = options.initialState.data;
    this.operation_ref = options.initialState.operation_ref
    this.status = options.initialState.status
    this._isTraitement = options.initialState.is_traitement
    this.SERVICE = this.data

    //console.log('data=> ', this.SERVICE);
    this.custumData = options.initialState.custom_data

    this.OPERATION_REF = this.operation_ref
    // console.log('OPERATION REF ==> ',this.OPERATION_REF)
    console.log('dataffff ==> ', this.data)
    console.log('istraitementhh ==> ', this._isTraitement)
    console.log('CUSTOMDATA ==> ', this.custumData)

    this.verifStatus(this.status || 'OK')
    console.log(this.STATUS)



    try {
      if (this._isTraitement == 1) {
        this.IS_TRAITEMENT = true
      }
      if (this.SERVICE.resp_template != null) {
        this.ALLOW_MISE_EN_FORME = true
      }

    } catch (e) {

    }

    let Formdata = {
      dynamic_field: this.formBuilder.array([])
    }
    this.demandeForm = this.formBuilder.group(Formdata);


    this.getServiceDetails(this.SERVICE.ref)
    this.getInformationFromCustomData()
    //this.getElectronicDetail(this.operation_ref)

  }
  closeWithMessage(message: string) {
    this.modalRef.hide();
    this.modalRef.onHidden.emit(message);
  }
  _closeWithMessage(message: string) {
    this.modalService.hide();
    this.modalRef.onHidden.emit(message);
  }

  async getInformationFromCustomData() {
    try {
      console.log(this.custumData)
      this.traitement_ref = JSON.parse(this.custumData).traitement_ref
      console.log('traitement_ref ', this.traitement_ref);
      if (this.traitement_ref != null) {
        this.can_show = false;
      }
      this.operation_ref_ext = JSON.parse(this.custumData).operation_ref

    } catch (e) {

    }

  }

  async getElectronicDetail(operation_ref) {
    this.service.getEDocument(operation_ref).subscribe((res: any) => {
      this.alerte.successNotification('Document électronique disponible ')
      this.ELECTRONIC_DOC = true
      console.log('response ======> ',res)
      this.ELECTRONIC_DOC_DETAIL = res
    }, (error: any) => {
      //this.loading = false
      //this.alerte.errorNotification('Aucun document trouver')
      this.ELECTRONIC_DOC = false
    })

  }
  getEDoc() {
    if (this.ELECTRONIC_DOC_DETAIL == null) {
      this.alerte.warningNotification('Aucun document trouver')
    } else {
      let link = this.ELECTRONIC_DOC_DETAIL.documentlink
      window.open(link, '_blank');
    }



  }


  getFormattedDate(date): string {
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }
  async getdataForm() {
    await this.getFormulaires().then((res) => {
      console.log('first success', res);

      // if has the traitement is done ==> get the response of this
      if (this.traitement_ref != null) {
        this.getResponseOfTraitement()
      }

    })
  }

  async ngOnInit(): Promise<void> {

    this.getdataForm()

  }
  openModalVisualPiece(url_image: any) {
    const config: ModalOptions = {
      initialState: {
        data: url_image || null,
        url: url_image || null,
        parentModal: null
      }
    }

    // Ouvrir le modal
    const modalRef = this.modalService.show(VisualizePieceComponent, Object.assign({}, config, { class: 'modal-lg  ' }));

    // Mettre à jour l'option initialState avec le modalRef
  }

  verifStatus(sendedStatus: any) {
    let nn_allowed_status_for_traitement = ['NEW', 'WAITING E-SIGNATURE', 'FINISH', 'CLOSE', 'REJECTED', 'FINISH', 'CLOSE', 'REJECTED', 'FAILED']
    let nn_allowed_status_for_complement = ['NEW', 'WAITING E-SIGNATURE', 'FINISH', 'CLOSE', 'WAITING COMPLEMENT', 'REJECTED', 'FINISH', 'CLOSE', 'REJECTED', 'FAILED']
    for (let statut of nn_allowed_status_for_traitement) {
      if (sendedStatus == statut) {
        this.STATUS = 'NOK'
      }
    }

    for (let statut of nn_allowed_status_for_complement) {
      if (sendedStatus == statut) {
        this.STATUS_COMPLEMENT = 'NOK'
      }
    }
  }
  getFileInputId(formIndex: number, entryKey: string): string {
    console.log('fddffd', `file-${formIndex}`);

    return `file-${formIndex}-${entryKey}`;
  }


  private isFirstCall = true;


  // supprimer les doublons de form.ref
  removeDuplicatesByFormRef(data: any[]): any[] {
    return data.filter((item, index, self) =>
      index === self.findIndex(t => t.formulaire.ref === item.formulaire.ref)
    );
  }

  getFormulaires(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.loadingServiceForms = true;
      this.ngxService.startLoader('detaildemande');
      this.service.getServiceFormsWithEntriesAndValue(this.OPERATION_REF).subscribe((res: any) => {
        console.log({ 'getttfffoview demande': res });

        // if (this.isFirstCall) {
        //   this.DEMANDE_TO_FORMS = res;
        //   this.isFirstCall = false;
        // } else {
        //   // Sinon, on concatène les nouvelles données avec les anciennes (la reponse du traitement)

        //   this.DEMANDE_TO_FORMS = [...res,...this.DEMANDE_TO_FORMS];

        // }
        this.DEMANDE_TO_FORMS = this.removeDuplicatesByFormRef([...res, ...this.DEMANDE_TO_FORMS]);


        console.log('after concat => ', this.DEMANDE_TO_FORMS);

        this.KEYS = [];
        this.KEYS_GEN = [];

        if (this.DEMANDE_TO_FORMS.length > 0) {
          for (let form of this.DEMANDE_TO_FORMS) {
            for (let entry_key of form.formulaire.entries) {
              const keyValuePair = {};
              keyValuePair[form.formulaire.ref + '#' + entry_key.key] = entry_key.value;
              const jsonStr = JSON.stringify(keyValuePair);
              this.KEYS_GEN.push(JSON.parse(jsonStr));
            }
          }
        } else {
          this.alerte.warningNotification('', 'Un problème est survenu lors de la récupération du formulaire !');
          this.closeAllDialogs();
        }

        let data = {
          dynamic_field: this.formBuilder.array(this.KEYS)
        };
        this.demandeForm = this.formBuilder.group(data);

        if (this.DEMANDE_TO_FORMS.length !== 0) {
          this.noForm = false;
        }

        setTimeout(() => {
          this.loadingServiceForms = false;
          resolve(); // Résoudre la promesse une fois l'appel terminé
        }, 3);

        this.ngxService.stopLoader('detaildemande');
      }, (error: any) => {
        this.ngxService.stopLoader('detaildemande');
        this.loadingServiceForms = false;
        this.alerte.warningNotification('Erreur', 'Aucune information trouvée pour cette demande');
        this.bsrefModal.hide();
        reject(error); // Rejeter la promesse en cas d'erreur
      });
    });
  }



  saveDoc(){
    this.alerte.successNotification('Sauvegarde','Modification Suavegard3')
  }

  genererDoc() {

    const config: ModalOptions = {
      initialState: {
        data: this.SERVICE,
        operation_ref: this.OPERATION_REF,
        KEYS_GEN: this.KEYS_GEN,
        data_from_request: this.DEMANDE_TO_FORMS,
        custom_data: this.custumData
      }
    }

    console.log('custum dataaaa ===>', this.custumData)
    if (this.SERVICE != null) {
      const modaRef = this.modalService.show(DocumentGenerationPublicComponent, Object.assign({}, config, { class: 'modal-lg  ' }));
      // modalRef.content.parentModal = modalRef;l

    } else {
      this.alerte.errorNotification('Demande ', 'Une Erreur est survenue lors de la recuperation des services')
    }

  }

  openMFFormDialog() {

    const config: ModalOptions = {
      initialState: {
        data: {ref:this.SERVICE.resp_template, label:'Mise en forme', type: 'MF'},
        operation_ref: this.OPERATION_REF,
        show_signature: false,
        is_mf: true,
        data_from_request: this.DEMANDE_TO_FORMS,
        template: this.SERVICE.related_service_detail.resp_template
      }
    }
    console.log('the service===> ', this.SERVICE.resp_template);

    if (this.SERVICE.resp_template != null) {
      return new Promise<string>((resolve, reject) => {
        const modalRef = this.modalService.show(AddPublicServiceComponent, Object.assign({}, config, { class: 'modal-xl  ' }));
        modalRef.content.parentModal = modalRef;
        modalRef.onHidden.subscribe((value: string) => {
          console.log('after traiteme', value);
          resolve(value); // Résoudre la promesse avec la valeur retournée
          console.log('after traiteme', value);

        });
      }).then(async (value: string) => {
        if (value == "for_close") {
          console.log('inthe-view-details', value);

          this.closeWithMessage("for_refresh")
          // return this.getResponseOfTraitement(service, operation_ref, status, custom_data);

        }


      });

      // modalRef.content.parentModal = modalRef;

    } else {
      this.alerte.errorNotification('Demande ', 'Une Erreur est survenue lors de la recuperation des services')
    }

  }


  openTraitementFormDialog() {

    const config: ModalOptions = {
      initialState: {
        data: this.SERVICE.related_service_detail,
        operation_ref: this.OPERATION_REF,
        show_signature: true,
        data_from_request: this.DEMANDE_TO_FORMS
      }
    }
    console.log('the service===> ', this.SERVICE.related_service_detail);

    if (this.SERVICE.related_service_detail != null) {
      return new Promise<string>((resolve, reject) => {
        const modalRef = this.modalService.show(AddPublicServiceComponent, Object.assign({}, config, { class: 'modal-xl  ' }));
        modalRef.content.parentModal = modalRef;
        modalRef.onHidden.subscribe((value: string) => {
          console.log('after traiteme', value);
          resolve(value); // Résoudre la promesse avec la valeur retournée
          console.log('after traiteme', value);

        });
      }).then(async (value: string) => {
        if (value == "for_close") {
          console.log('inthe-view-details', value);

          this.closeWithMessage("for_refresh")
          // return this.getResponseOfTraitement(service, operation_ref, status, custom_data);

        }


      });

      // modalRef.content.parentModal = modalRef;

    } else {
      this.alerte.errorNotification('Demande ', 'Une Erreur est survenue lors de la recuperation des services')
    }

  }

  openModalAddPieceDemande() {
    const config: ModalOptions = {
      initialState: {
        data: this.SERVICE.related_service_detail,
        operation_ref: this.OPERATION_REF,
        data_from_request: this.DEMANDE_TO_FORMS
      }
    }
    console.log('openModalAddPieceDemande');

    return new Promise<string>((resolve, reject) => {
      const modalRef = this.modalService.show(AddPiecePublicdemandeComponent, Object.assign({}, config, { class: 'modal-xl  ' }));
      modalRef.onHidden.subscribe((value: string) => {
        resolve(value); // Résoudre la promesse avec la valeur retournée
        console.log('after traiteme', value);

      });
    }).then(async (value: string) => {
      if (value == "for_close") {
        this.closeWithMessage("for_refresh")
        // return this.getResponseOfTraitement(service, operation_ref, status, custom_data);

      } else if (value == "for_open") {
        this.closeWithMessage('for_open')
      }


    });

  }

  async getResponseOfTraitement(service: any = null, operation_ref: any = null, custom_data: any = null) {
    const is_traitemant = 0
    this._isTraitement = is_traitemant
    service = this.data
    this.custumData = custom_data
    console.log('the cussss', this.custumData);

    this.OPERATION_REF = this.traitement_ref != null ? this.traitement_ref : this.operation_ref_ext != null ? this.operation_ref_ext : null
    await this.getFormulaires()
    this.can_show = true;
    this.getServiceDetails(this.SERVICE.ref)
    const config: ModalOptions = {
      initialState: {
        data: service,
        operation_ref: operation_ref,
        custom_data: custom_data,
        is_traitement: is_traitemant
      }
    }
    if (service != null) {
      // deuxieme appel de getformulaires
      console.log('deuxieme');



      // modalRef.content.parentModal = modalRef;

    } else {
      this.alerte.errorNotification('Demande ', 'Une Erreur est survenue lors de la recuperation des services')
    }

  }


  getServiceDetails(service_ref: any) {
    this.service.getService(service_ref).subscribe((res: any) => {
      //console.log(this.formulaire.my_inputs)
      this.SERVICE = res
      console.log({ 'service details ': res })
      //console.log(this.FORM_INPUT)
      //this.loading = false

    }, (error: any) => {
      //this.loading = false
      this.alerte.errorNotification('SERVICE DETAIL', error.error)
    })
  }

  closeAllDialogs() {

    // this.modalRef.hide();
    // this.ngxService.stop();
    this.closeWithMessage('uu')

  }

  launchDialog(dialogRef: any) {
    dialogRef.disableClose = true;
    dialogRef.afterClosed().subscribe();
  }

}
